import { isNil } from "@/utils/lodash";

export const createParams = (...params) => {
  if (!params) return "";
  if (params.length === 0) return "";
  return "?".concat(params.filter((it) => it).join("&"));
};

export const createEqualParam = (name, value) =>
  isNil(value) ? "" : `${name}=${value}`;
